module.exports = __webpack_public_path__ + "static/media/29ADMSPC9.f87b3f6e.jpg";